"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _Interactions = require("customer-data-communicator/schema/communicator/interaction/Interactions");

var _InteractionRecord = _interopRequireDefault(require("customer-data-objects/interaction/InteractionRecord"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _RichTextEditorModules = require("customer-data-rte/config/RichTextEditorModules");

var _RichTextEditableComponent = _interopRequireDefault(require("customer-data-rte/components/RichTextEditableComponent"));

var _createRichTextEditor = _interopRequireDefault(require("./createRichTextEditor"));

var EMPTY_BODY = '';
var propTypes = {
  connectRte: _react.PropTypes.func.isRequired,
  initialEditorState: _react.PropTypes.object,
  interaction: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_InteractionRecord.default), _react.PropTypes.instanceOf(_EngagementRecord.default)]).isRequired,
  RichTextEditor: _react.PropTypes.instanceOf(Function).isRequired
};

var _default = function _default(InteractionComponent) {
  var EditableInteractionComponent =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(EditableInteractionComponent, _Component);

    function EditableInteractionComponent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, EditableInteractionComponent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EditableInteractionComponent).call(this, props));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      _this.state = {
        editorState: null
      };
      return _this;
    }

    (0, _createClass2.default)(EditableInteractionComponent, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        var _this$props = this.props,
            connectRte = _this$props.connectRte,
            RichTextEditor = _this$props.RichTextEditor;
        this.RichTextEditor = (0, _createRichTextEditor.default)({
          connectRte: connectRte,
          RichTextEditor: RichTextEditor
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(newProps) {
        if ((0, _Interactions.isInteractionReset)(this.props.interaction, newProps.interaction)) {
          this.handleRteReset();
        }

        if (this.props.interaction.metadata.get('body') !== newProps.interaction.metadata.get('body')) {
          if (!this.rteResults) {
            return;
          }

          var body = newProps.interaction.metadata.get('body') || EMPTY_BODY;
          this.rteResults = this.rteResults.pushContent(body);
          this.setState({
            editorState: this.rteResults.editorState
          });
        }
      }
    }, {
      key: "handleRteStateCreated",
      value: function handleRteStateCreated(rteResults) {
        var _this$props2 = this.props,
            initialEditorState = _this$props2.initialEditorState,
            interaction = _this$props2.interaction;
        this.rteResults = rteResults;

        if (initialEditorState) {
          this.setState({
            editorState: initialEditorState
          });
        } else {
          var body = interaction.metadata.get('body');

          if (body) {
            var results = rteResults.pushContent(body);

            if (results.hasContent()) {
              this.rteResults = results;
            }
          } else if (interaction.rawEditorContent) {
            this.rteResults = rteResults.pushRawEditorContent(interaction.rawEditorContent);
          }

          this.setState({
            editorState: this.rteResults.editorState
          });
        }
      }
    }, {
      key: "handleRteStateChanged",
      value: function handleRteStateChanged(rteResults) {
        this.rteResults = rteResults;
      }
    }, {
      key: "handleRteRestore",
      value: function handleRteRestore(content) {
        if (!this.rteResults) {
          return;
        }

        var results = this.rteResults.pushContent(content);

        if (results.hasContent()) {
          this.rteResults = results;
          this.setState({
            editorState: this.rteResults.editorState
          });
        }
      }
    }, {
      key: "handleRteReset",
      value: function handleRteReset() {
        if (!this.rteResults) {
          return;
        }

        this.rteResults = this.rteResults.resetEditorState();
        this.setState({
          editorState: this.rteResults.editorState
        });
      }
    }, {
      key: "render",
      value: function render() {
        var editorState = this.state.editorState;
        return _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, this.props, {
          editorState: editorState,
          hasRteContent: !!this.rteResults && this.rteResults.hasContent(),
          onRteChange: this.handleRteStateChanged,
          onRteStateCreated: this.handleRteStateCreated,
          onRteRestore: this.handleRteRestore,
          onRteReset: this.handleRteReset,
          RichTextEditor: this.RichTextEditor
        }));
      }
    }]);
    return EditableInteractionComponent;
  }(_react.Component);

  EditableInteractionComponent.WrappedComponent = InteractionComponent;
  EditableInteractionComponent.displayName = "EditableInteraction(" + InteractionComponent.displayName + ")";
  EditableInteractionComponent.propTypes = propTypes;
  return (0, _RichTextEditableComponent.default)(EditableInteractionComponent, _RichTextEditorModules.richTextEditorModules);
};

exports.default = _default;
module.exports = exports.default;